export class AvailableRole {
    role: string;
    features: string[];
    roleType: 'base' | 'additional';
    selectable: boolean;

    checked?: boolean = false;

    constructor(role: string, features: string[], roleType: "base" | "additional", selectable: boolean) {
        this.role = role;
        this.features = features;
        this.roleType = roleType;
        this.selectable = selectable;
    }

    get id(): string {
        return this.role;
    }

    get translateKey(): string {
        return `teamMember.role_${this.role}`;
    }

    get description(): string {
        return `teamMember.role_${this.role}.desc`;
    }

    static defauBasetRole() { //
        return new AvailableRole("member", [], "base", true);
    }
}

export class AllRoles {
    availableFeatures: string[];
    availableRoles: AvailableRole[];

    constructor(availableFeatures: string[], availableRoles: AvailableRole[]) {
        this.availableFeatures = availableFeatures;
        this.availableRoles = availableRoles.map(ar => new AvailableRole(ar.role, ar.features, ar.roleType, ar.selectable));
    }

    baseRoles(): AvailableRole[] {
        return this.availableRoles.filter(role => role.roleType === 'base');
    }

    additionalRolesOf(userRoles: string[]): AvailableRole[] {
        return this.availableRoles
            .filter(role => role.roleType === 'additional')
            .map(ar => {
                ar.checked = userRoles.indexOf(ar.id) !== -1;
                return ar;
            });
    }

    baseRoleOf(userRoles: string[]): AvailableRole {
        const baseRole = this.baseRoles().filter(br => userRoles.indexOf(br.role) !== -1);
        if (baseRole?.length > 0) {
            return baseRole[0];
        } else { // should not happen
            return AvailableRole.defauBasetRole();
        }
    }

    activatedFeatures(userRoles: string[]): ActiveFeature[] {
        const allUserRoles =
            [this.baseRoleOf(userRoles)]
                .concat(
                    this.additionalRolesOf(userRoles).filter(r => r.checked)
                );
        const userEnabledFeatures = allUserRoles.flatMap(role => role.features);
        let uniqueItems = [...new Set(userEnabledFeatures)]

        return this.availableFeatures.map(feat => {
            if (uniqueItems.includes(feat)) {
                return new ActiveFeature(feat, true)
            } else {
                return new ActiveFeature(feat, false)
            }
        })
    }
}


export class ActiveFeature {
    name: string;
    active: boolean;

    constructor(name: string, active: boolean) {
        this.name = name;
        this.active = active;
    }
}